import React from "react";

import { AssistantMutedText } from "../../styles";
import {
  AssistantFeatureActions,
  StyledAssistantFeatureWalkthroughActionsAssistantActionButton,
} from "./styles";
import { IAssistantFeatureWalkthroughActionsProps } from "./types";

const AssistantFeatureWalkthroughActions: React.FC<IAssistantFeatureWalkthroughActionsProps> =
  ({ completed, skipped, finished, onDone, pending, onFinish }) => (
    <AssistantFeatureActions>
      <AssistantMutedText variant="subtitle9" flex={1} minWidth={0}>
        {finished
          ? "Your scenario results are unchanged."
          : `${completed} completed · ${skipped} skipped`}
      </AssistantMutedText>
      <StyledAssistantFeatureWalkthroughActionsAssistantActionButton
        variant="contained"
        color="secondary"
        round
        fullWidth={false}
        disabled={pending}
        onClick={finished ? onDone : onFinish}
      >
        {finished ? "Done" : "Finish walkthrough"}
      </StyledAssistantFeatureWalkthroughActionsAssistantActionButton>
    </AssistantFeatureActions>
  );

export default AssistantFeatureWalkthroughActions;
